import { render } from "./HiTextarea.vue?vue&type=template&id=d1908c84&scoped=true"
import script from "./HiTextarea.vue?vue&type=script&lang=js"
export * from "./HiTextarea.vue?vue&type=script&lang=js"

import "./HiTextarea.vue?vue&type=style&index=0&id=d1908c84&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1908c84"]])

export default __exports__